import type { Option } from '@automata/workflow-builder';
import { ReactNode, createContext, useContext } from 'react';

export type FilterExtrasContext = {
  typeOptions: string[];
  tagOptions: Option[];
};

const Ctx = createContext<FilterExtrasContext>({
  typeOptions: [],
  tagOptions: [],
});

export const FilterProvider = ({
  value,
  children,
}: {
  value: FilterExtrasContext;
  children: ReactNode;
}) => <Ctx.Provider value={value}>{children}</Ctx.Provider>;

export const useFilterExtras = (): FilterExtrasContext => useContext(Ctx);
